/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import { CreditAppSavedSectionInfo } from '../../../apollo/fragments/CreditAppSavedSectionInfo.gql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateFinancialDetails_updateCreditApplication_CreditApplication_financeInfo_CreditApplicationFinanceInfo = { readonly __typename: 'CreditApplicationFinanceInfo', readonly desiredCredit: any | null, readonly expectedSpend: any | null };

export type UpdateFinancialDetails_updateCreditApplication_CreditApplication_businessInfo_CreditApplicationBusinessInfo_accountingSoftware_CreditApplicationAccountingSoftware = { readonly __typename: 'CreditApplicationAccountingSoftware', readonly accountingSoftwareKey: string | null };

export type UpdateFinancialDetails_updateCreditApplication_CreditApplication_businessInfo_CreditApplicationBusinessInfo = { readonly __typename: 'CreditApplicationBusinessInfo', readonly annualRevenue: any | null, readonly accountingSoftware: UpdateFinancialDetails_updateCreditApplication_CreditApplication_businessInfo_CreditApplicationBusinessInfo_accountingSoftware_CreditApplicationAccountingSoftware | null };

export type UpdateFinancialDetails_updateCreditApplication_CreditApplication_outsourcedAccountant_CreditApplicationPerson = { readonly __typename: 'CreditApplicationPerson', readonly id: string | null, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null };

export type UpdateFinancialDetails_updateCreditApplication_CreditApplication_savedSectionsInfo_SavedSectionsInfo = { readonly __typename: 'SavedSectionsInfo', readonly sectionName: _Types.SectionName, readonly completedAt: any | null, readonly completionStatus: _Types.CompletionStatus | null };

export type UpdateFinancialDetails_updateCreditApplication_CreditApplication = { readonly __typename: 'CreditApplication', readonly salesforceCreditId: string, readonly fetchedAt: any | null, readonly billingCycle: _Types.BillingCycle | null, readonly hasOutsourcedAccountant: boolean | null, readonly financeInfo: UpdateFinancialDetails_updateCreditApplication_CreditApplication_financeInfo_CreditApplicationFinanceInfo | null, readonly businessInfo: UpdateFinancialDetails_updateCreditApplication_CreditApplication_businessInfo_CreditApplicationBusinessInfo | null, readonly outsourcedAccountant: UpdateFinancialDetails_updateCreditApplication_CreditApplication_outsourcedAccountant_CreditApplicationPerson | null, readonly savedSectionsInfo: ReadonlyArray<UpdateFinancialDetails_updateCreditApplication_CreditApplication_savedSectionsInfo_SavedSectionsInfo | null> | null };

export type UpdateFinancialDetails_Mutation = { readonly __typename: 'Mutation', readonly updateCreditApplication: UpdateFinancialDetails_updateCreditApplication_CreditApplication };


export type UpdateFinancialDetailsVariables = _Types.Exact<{
  creditApplicationId: _Types.Scalars['ID']['input'];
  billingCycle?: _Types.InputMaybe<_Types.BillingCycle>;
  hasOutsourcedAccountant?: _Types.InputMaybe<_Types.Scalars['Boolean']['input']>;
  outsourcedAccountant?: _Types.InputMaybe<_Types.PersonInput>;
  businessInfo?: _Types.InputMaybe<_Types.BusinessInfoInput>;
  financeInfo?: _Types.InputMaybe<_Types.FinanceInfoInput>;
}>;


export type UpdateFinancialDetails = UpdateFinancialDetails_Mutation;


export const UpdateFinancialDetailsDocument = gql`
    mutation UpdateFinancialDetails($creditApplicationId: ID!, $billingCycle: BillingCycle, $hasOutsourcedAccountant: Boolean, $outsourcedAccountant: PersonInput, $businessInfo: BusinessInfoInput, $financeInfo: FinanceInfoInput) {
  updateCreditApplication(
    creditApplicationId: $creditApplicationId
    businessInfo: $businessInfo
    financeInfo: $financeInfo
    hasOutsourcedAccountant: $hasOutsourcedAccountant
    outsourcedAccountant: $outsourcedAccountant
    billingCycle: $billingCycle
  ) {
    salesforceCreditId
    fetchedAt
    financeInfo {
      desiredCredit
      expectedSpend
    }
    billingCycle
    businessInfo {
      annualRevenue
      accountingSoftware {
        accountingSoftwareKey
      }
    }
    hasOutsourcedAccountant
    outsourcedAccountant {
      id
      firstName
      lastName
      email
    }
    ...CreditAppSavedSectionInfo
  }
}
    ${CreditAppSavedSectionInfo}`;
export type UpdateFinancialDetailsMutationFn = Apollo.MutationFunction<UpdateFinancialDetails, UpdateFinancialDetailsVariables>;

/**
 * __useUpdateFinancialDetails__
 *
 * To run a mutation, you first call `useUpdateFinancialDetails` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFinancialDetails` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFinancialDetails, { data, loading, error }] = useUpdateFinancialDetails({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *      billingCycle: // value for 'billingCycle'
 *      hasOutsourcedAccountant: // value for 'hasOutsourcedAccountant'
 *      outsourcedAccountant: // value for 'outsourcedAccountant'
 *      businessInfo: // value for 'businessInfo'
 *      financeInfo: // value for 'financeInfo'
 *   },
 * });
 */
export function useUpdateFinancialDetails(baseOptions?: Apollo.MutationHookOptions<UpdateFinancialDetails, UpdateFinancialDetailsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFinancialDetails, UpdateFinancialDetailsVariables>(UpdateFinancialDetailsDocument, options);
      }
export type UpdateFinancialDetailsHookResult = ReturnType<typeof useUpdateFinancialDetails>;
export type UpdateFinancialDetailsMutationResult = Apollo.MutationResult<UpdateFinancialDetails>;
export type UpdateFinancialDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateFinancialDetails, UpdateFinancialDetailsVariables>;